
// import Oidc from "oidc-client";
// import { openIdConnectSettings } from "@/store/oidc-config";
// var mgr = new Oidc.UserManager(openIdConnectSettings).signinSilentCallback();
import AuthService from "@/core/services/Authservice";
const auth = new AuthService();

import { defineComponent } from "vue";
export default defineComponent({
  name: "silent-renew",
  setup() {
    auth.signinSilentCallback();
    // console.log(auth.signinSilentCallback());
  }
});
